import type { JSX } from 'react';

import { Breadcrumbs } from '@change/ds-core-ui';

import { CmsHtml } from 'src/app/shared/components/cms';

import { usePageBody } from './hooks/usePageBody';

export function PageBody(): JSX.Element {
	const {
		data: { html, styles, breadcrumbItems },
	} = usePageBody();

	return (
		<>
			<div className="[&_.business-model-icon]:w-[70px] md:[&_.business-model-icon]:w-[94px]">
				<CmsHtml html={html} styles={styles} />
			</div>
			<div className="container">
				<Breadcrumbs items={breadcrumbItems} maxVisible={2} maxVisibleTablet={1} />
			</div>
		</>
	);
}
